<script>
import Vue from 'vue';

export default {
  props:['content', 'initialLength'],
  data() {
    return {
      length:this.initialLength
    };
  },
  methods: {
    loadMore() {
      if (this.length > this.content.length) return;
      this.length = this.length + this.initialLength;
    },
  },
  computed: {
    listLoaded() {
      return this.content.slice(0, this.length);
    },
    hasMore() {
        return this.content.length > this.listLoaded.length;
    },
  },
  render(h) {
    return this.$scopedSlots.default({
      loadMore: this.loadMore,
      hasMore: this.hasMore,
      list: this.listLoaded
    });
  },
};
</script>

